

























import {Component, Prop, Vue} from 'vue-property-decorator';
import {ComponentDoc} from "vue-inbrowser-compiler-utils"

@Component
export default class JdiContent extends Vue {
    @Prop() title!: string;
    @Prop({default: null}) docs!: ComponentDoc;


    get published() {
        if (!this.docs || !this.docs.tags || !this.docs.tags.hasOwnProperty('published')) return '';
        return (this.docs.tags.published[0] as any).description;
    }

    get status() {
        if (!this.docs || !this.docs.tags || !this.docs.tags.hasOwnProperty('status')) return 'unknown';
        return (this.docs.tags.status[0] as any).description;
    }

    get statusClasses(): Array<string> {
        switch (this.status) {
            case ('stable'): return ['jds-text-green-700'];
            case ('draft'): return ['jds-text-fuchsia-700'];
            default: return ['jds-text-grey-500'];
        }
    }
}
